import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { IonLabel } from '@ionic/react'

import { UserName } from '@components/atoms/UserName'
import { ListItem } from '@components/molecules/ListItem'
import { List } from '@components/organisms/List'

import { IUser } from '@/services/findUsers'

export type ILeaderboardListItem = {
  votes: number
  creatorVideoPreview: string
  contestantActivityId: string
} & IUser

export const LeaderboardList: FC<{ items: ILeaderboardListItem[] }> = ({
  items,
}) => {
  const { t } = useTranslation('common')

  return (
    <List className="py-2">
      {items
        ? items?.map((item: ILeaderboardListItem, index: number) => (
            <ListItem
              item={item}
              isOrdered
              isLeaderboard
              index={index}
              key={item.userId}
            >
              <IonLabel>
                <div className="flex justify-between">
                  <Link to={`/@${item?.username}`}>
                    <UserName name={item.username} />
                  </Link>
                  <span>{item.votes}</span>
                </div>
              </IonLabel>
            </ListItem>
          ))
        : t('contest.emptyLeaderboard')}
    </List>
  )
}
